export const GET_DATA_CURRENCY = "GET_DATA_CURRENCY";